import type { FC, PropsWithChildren } from "react";

export const LimitHeader: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<div className="flex flex-col gap-1 mb-6">
			{children}
		</div>
	);
};
